var breadcrumb = $('.breadcrumb-container .breadcrumbs');
var metaNav = $('nav.meta');

$(function () {
    positionBreadcrumb();

    $(window).on('resize', function () {
        positionBreadcrumb();
    });
});

function positionBreadcrumb() {
    var metaNavOffset = metaNav.offset().left;
    var breadcrumbOffset = breadcrumb.offset().left;
    if (metaNav.css('display') === 'none') {
        breadcrumb.css('width', '100%');
    } else {
        breadcrumb.css('width', metaNavOffset - breadcrumbOffset - 20);
    }
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/breadcrumb/index.js
 **/